export default __webpack_public_path__ + "static/media/shopping-cart.b1dff17a.svg";